import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLang } from '../../hooks/useLang';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen } from '@fortawesome/free-solid-svg-icons';
import '../../styles/auth/ForgotPassword.scss';

const ForgotPassword = () => {
    const { urlLanguage } = useLang();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        try {
            const response = await fetch('/api/auth/forgot-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });

            const json = await response.json();

            if (!response.ok) {
                setError(json.error || 'Failed to send reset email.');
            } else {
                // Navigate to Reset Password page, passing email in state
                navigate(urlLanguage('/reset-password'), { state: { email } });
            }
        } catch (err) {
            console.error(err);
            setError('Network error occurred.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="forgot-password-page">
            <div className="auth-logo">
                <FontAwesomeIcon icon={faBookOpen} className="auth-logo-icon" />
                YeniDers
            </div>

            <div className="auth-header">
                <h1>Forgot Password</h1>
                <p>Enter your email to receive a reset code</p>
            </div>

            <div className="auth-card">
                <form onSubmit={handleSubmit}>
                    {error && <div className="auth-error">{error}</div>}

                    <div className="auth-form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            placeholder="you@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <button type="submit" className="auth-submit-btn" disabled={isLoading}>
                        {isLoading ? 'Sending...' : 'Send Reset Code'}
                    </button>
                </form>

                <div className="auth-footer">
                    Remember your password? <Link to={urlLanguage('/login')}>Log in</Link>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
